module.exports = __webpack_public_path__ + "media/images/flags/ag-5929ca9ff0f160f96fb5ed45aa08fd12.svg";